<div class="inner-content">
    <div class="password-change">

        <form (ngSubmit)="onSubmit()" [formGroup]="form">
            <h2>
                Wypełnij informacje na temat osoby kontaktowej:
            </h2>
            <cmn-label class="dark">
                <input type="text"
                       formControlName="firstName"
                       autocomplete="off"
                       placeholder="Imię"
                       kendoTextBox/>
                <cmn-errors [control]="form.get('firstName')"></cmn-errors>
            </cmn-label>
            <cmn-label class="dark">
                <input type="text"
                       formControlName="lastName"
                       autocomplete="off"
                       placeholder="Nazwisko"
                       kendoTextBox/>
                <cmn-errors [control]="form.get('lastName')"></cmn-errors>
            </cmn-label>
            <cmn-label class="dark">
                <input type="text"
                       formControlName="email"
                       autocomplete="off"
                       placeholder="Adres e-mail"
                       kendoTextBox/>
                <cmn-errors [control]="form.get('email')"></cmn-errors>
            </cmn-label>
            <cmn-label class="dark">
                <input type="text"
                       formControlName="phone"
                       autocomplete="off"
                       placeholder="Numer telefonu"
                       kendoTextBox/>
                <cmn-errors [control]="form.get('phone')"></cmn-errors>
            </cmn-label>
            <cmn-label class="dark">
                <input type="text"
                       formControlName="companyName"
                       autocomplete="off"
                       placeholder="Firma"
                       kendoTextBox/>
                <cmn-errors [control]="form.get('companyName')"></cmn-errors>
            </cmn-label>

            <button type="submit"
                    kendoButton
                    [primary]="true"
                    class="big"
            >
                Zapisz kontakt
            </button>

        </form>
    </div>
</div>

<ns-fixed-element position="top">
    <div class="mobile-floater">
        <a routerLink="../">
            Powrót
        </a>
    </div>
</ns-fixed-element>
